import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { USERAUTH_TENANT_BASE_PATH } from '../../../../../features/userauth/tenant/userauth-tenant-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/tenant/_tenant')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'tenant-list',
        label: 'Tenants',
        to: USERAUTH_TENANT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
